import { LoanProposalStatus, Proposal } from "@cf247/pricing";

export default function useMapProposals(props: Proposal[], dealerId: number){
  if (!props || !Array.isArray(props)) {
    return [];
  }

  props.forEach(p => {
    // Banned dealer per lender override
    if(p.bannedDealerIds && p.bannedDealerIds.length && p.bannedDealerIds.includes(dealerId)){
      p.loanProposalStatus = LoanProposalStatus[LoanProposalStatus.Declined]; 
    }
    
  })

  return props;
}